var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner)?_c('div',{staticClass:"banner-landing"},[_c('h1',[_vm._v(_vm._s(_vm.banner.landingPage.title))]),_c('p',[_vm._v(_vm._s(_vm.banner.landingPage.description)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }